import { isNil } from 'ramda';
import React from 'react';
import { GetSeatConfigurationsTask } from '~admin/interactor/location/perform-get-seat-configurations';
import { SeatConfigurationData } from '~admin/model/seat-configuration-data';
import { useCreateEditEventFlowStore } from '~admin/store/create-edit-event-flow-store-provider';
import { SelectFieldTask } from '~admin/view/components/ui/form/fields/field-select-task.component';
import { SelectFieldOption } from '~common/components/select.component';
import { isNilOrEmpty } from '~common/helper/global';
import { useSuccessReaction } from '~common/hook/use-reaction';

interface Props {
  name: string;
  label: string;
  task: GetSeatConfigurationsTask;
  eventLocationId: number;
  onEmpty?: VoidFunction;
  disabled?: boolean;
}

export const SeatConfigurationsDropdown: React.FunctionComponent<Props> = ({
  name,
  label,
  task,
  eventLocationId,
  onEmpty,
  disabled,
}) => {
  const createEventFlowStore = useCreateEditEventFlowStore();

  /**
   * Save the list of seat configuration when location is chosen
   */
  useSuccessReaction(task, (result: SeatConfigurationData[]): void => {
    if (!isNil(result)) {
      createEventFlowStore.updateSeatConfigurations(result);
    }

    if (isNilOrEmpty(result)) {
      onEmpty?.();
    }
  });

  return (
    <SelectFieldTask
      name={name}
      label={label}
      task={task}
      taskArgs={[eventLocationId]}
      disabled={isNil(eventLocationId) || disabled}
      mapper={(result: SeatConfigurationData[]): SelectFieldOption[] =>
        result.map(({ id, name }) => ({
          name,
          value: id,
        }))
      }
    />
  );
};



// WEBPACK FOOTER //
// ./view/components/details/event-details/event-location-details/seat-configurations-dropdown.component.tsx